import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'fit-content'
  },
  main: {
    display: 'inline-flex',
    border: `1px solid ${theme.palette.grey[200]}`,
    backgroundColor: theme.palette.grey[200],
    borderRadius: 8,
    padding: 8
  },
  title: {
    fontWeight: 500,
    color: theme.palette.grey[800],
    marginBottom: 4,
    marginLeft: 8
  },
  item: {
    padding: '4px 16px',
    margin: '0 4px',
    fontSize: 14,
    color: theme.palette.grey[600],
    cursor: 'pointer',
    borderRadius: 6,
    userSelect: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.grey[400]
    }
  },
  active: {
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.grey[400]}`,
    color: theme.palette.text.primary
  }
}))

export default useStyles
